module.exports = __webpack_public_path__ + "static/media/Icon_cursor.f3cceca8.svg";